<template>
  <v-app>
    <SatForm class="form" :company="company" v-if="type == 'sat'"/>
    <LogisticsForm class="form" :company="company" v-if="type == 'logistics'"/>
  </v-app>
</template>

<script>

import SatForm from "@/components/SatForm";
import LogisticsForm from "./components/LogisticsForm.vue";

export default {
  name: 'App',
  components: { SatForm, LogisticsForm },
  data() {
    return {
      company: "fibraclim",
      type: "sat",
    }
  },
  created() {
    const url = location.href
    const params = new URLSearchParams(url.split("?")[1])
    const company = params.get("company")
    this.type = params.get("type") ?? "sat"
    if (company == "fibraclim") {
      this.company = "fibraclim"
    } else if (company == "climahosteleria") {
      this.company = "climahosteleria"
    } else if (company == "arilex") {
      this.company = "arilex"
    }
  }
};
</script>

<style scoped>
</style>